import { Injectable } from '@angular/core';
import { Http, Response} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {
  ComponentType,
  CompIDRowData,
  MeasurementToolsViewModel,
  Make, Model,
  ComponentList,
  CompartToolImageViewModel,
  MeasurementImage,
  GetComponentImage,
  BASE_URL,
  UpdateComponentSproket,
  ServerReturnMessage,
  MakeViewModel,
  GetComponentImageData,
  ComponentExtraDetailViewModel,
  ActionHistoryComponentData,
  UpdateComponentCost
 } from './manage-components.model';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { catchError, map } from 'rxjs/operators';
import { UpdateComponentImageViewModel } from '../GET_NEW_UI/inspections/inspection.model';
import { HttpParams } from '@angular/common/http';
@Injectable()
export class ManageComponentsService {



  componentTypeList: ComponentType[];
  componentList: ComponentList[];
  GetComponentImage: GetComponentImage[];
  compExtraDetails: CompIDRowData[];
  measurementToolsList: MeasurementToolsViewModel[];
  availableMakeList: Make[];
  availableModelList: Model[];
  measurementImage: MeasurementImage[];
  componentImage: GetComponentImage[];
  constructor(
    private _http: Http
  ) { }

  public getComponentType(): Observable<ComponentType[]> {
  

      return this._http
      .get(`${BASE_URL}/getAvailableCompartTypeList`)
      .map((response: Response) => {
        return <ComponentType[]>response.json()
      }).catch(this.handleError)

  }


  public getMeasurementTools(): Observable<MeasurementToolsViewModel[]> {
    // return this._http.get(`${BASE_URL}/GetAllMeasurementTools`)
    //   .pipe(
    //     map((response: any) => response), // Directly return the array or data part
    //     catchError(this.handleError)      // Handle errors if necessary
    //   );

      return this._http
      .get(`${BASE_URL}/GetAllMeasurementTools`)
      .map((response: Response) => {
        return <MeasurementToolsViewModel[]>response.json()
      }).catch(this.handleError)
  }


  public getComponentMakeList(): Observable<Make[]> {
    // return this._http
    // .get('api/setupequipment/GetMakeList')
    // .pipe(
    //   // Cast the response to MeasurementImage[]
    //   map((response: any) => response as Make[]),
    //   catchError(this.handleError)
    // );
    return this._http
    .get('api/setupequipment/GetMakeList')
      .map((response: Response) => {
        return <Make[]>response.json()
      }).catch(this.handleError)
  }

//getComaprtList



  public getMakeList(): Observable<Make[]> {

    return this._http.get('api/setupequipment/GetMakeList')
      .map((data: Response) => {
        return <Make[]>data.json()
      })
  }

  //Get Component Model List
  public getModelListV2(): Observable<Model[]> {
        return this._http
    .get(`${BASE_URL}/getAllModelList`)
      .map((response: Response) => {
        return <Model[]>response.json()
      }).catch(this.handleError)

  }
  
  public addComponentImages(imageUrl :string, ImageId :number, ComponentId:any) {
    const model = new UpdateComponentImageViewModel();
    model.ImageData = imageUrl;
    model.ImageId = ImageId;
    model.comparttype_auto = ComponentId;
    return this._http.post('api/Component/AddComponentImages', model)
      .pipe(catchError(this.handleError));
  }
  public addComponentToolImages(imageUrl: string, ImageName: string, toolId: any, ComponentId: any) {
    const model = new UpdateComponentImageViewModel();
    model.ImageData = imageUrl;
    model.ImageName = ImageName;
    model.tool_auto = toolId;
    model.comparttype_auto = ComponentId;
    return this._http.post('api/Component/AddComponentToolImages', model)
      .pipe(catchError(this.handleError));
  }
  //Get Component Model List
  public getModelList(){
    this._http.get(`${BASE_URL}/getAllModelList`)
      .map((data: Response) => {
        return data.json() as Model[];
      }).toPromise().then(x => {
        this.availableModelList = x;
      })
  }

  //Fill Mat Table of with Components details
  public getAllComponentList(progid: string, ComponentId: string, ComponentDescription: string, ComponentType: string, EquipMake: string, ComponentMake: string, EquipModel: string,Pitch: string): Observable<ComponentList[]> {

    let obj = {
      'progid': progid,
      'ComponentId': ComponentId,
      'ComponentDescription': ComponentDescription,
      'ComponentType': ComponentType,
      'EquipMake': EquipMake,
      'ComponentMake': ComponentMake,
      'EquipModel': EquipModel,
      'Pitch': Pitch
    };
    return this._http
      .post(`${BASE_URL}/GetComponents`, obj)
      .map((response: Response) => {
        return <ComponentList[]>response.json()
      }).catch(this.handleError)
  }

  public loadComponentImage(): Observable<GetComponentImageData> {

    return this._http.get(`${BASE_URL}/loadComponentImage`)
      .map((data: Response) => {
        return <GetComponentImageData>data.json()
      })
  }

  //new code for get componenttable list
  public GetComponentTableDetail(progid: string, ComponentId: string, ComponentDescription: string, ComponentType: string, EquipMake: string, ComponentMake: string, EquipModel: string): Observable<ComponentList[]> {
    let obj = {
      'progid': progid,
      'ComponentId': ComponentId,
      'ComponentDescription': ComponentDescription,
      'ComponentType': ComponentType,
      'EquipMake': EquipMake,
      'ComponentMake': ComponentMake,
      'EquipModel': EquipModel
    };
    return this._http
      .post(`${BASE_URL}/GetComponentTableDetailList`, obj)
      .map((response: Response) => {
        return <ComponentList[]>response.json()
      }).catch(this.handleError)
  }
  //end new code

  // Get Row data and fill other form fields
  public getComponentLisRowData(compartid_auto: string): Observable<CompIDRowData[]> {
    let obj = {
      'compartid_auto': compartid_auto
    };
    return this._http
      .post(`${BASE_URL}/getDetails`, obj)
      .map((response: Response) => {
        return <CompIDRowData[]>response.json()
      }).catch(this.handleError)
  }

  public getComponentExtraData(compartid_auto: string): Observable<ComponentExtraDetailViewModel[]> {
    
    let params={ compartid_auto: compartid_auto};
    return this._http.get(`${BASE_URL}/GetComponentExtraDetail`, { search: params }).share().map(
      (response: Response) => <ComponentExtraDetailViewModel[]>response.json()).catch(this.handleError);
  }

  //getMeasurement Images
  public getComponentMeasurementImg(Id: string): Observable<CompartToolImageViewModel[]> {
    let obj = {
      'Id': Id
    };
    return this._http
      .post(`${BASE_URL}/getCompartToolCombinationImage`, obj)
      .map((response: Response) => {
        return <CompartToolImageViewModel[]>response.json()
      }).catch(this.handleError)
  }

 // save Measurement Image details
  public saveMeasurementImage(compartid_auto: string, Title: string, ImageDataBase64: string, ToolId: number, ImageType: string): Observable<MeasurementImage[]> {

    let obj = {
      'compartid_auto': compartid_auto,
      'Title': Title,
      'ImageDataBase64': ImageDataBase64,
      'ToolId': ToolId,
      'ImageType': ImageType
    };
    return this._http
    .post(`${BASE_URL}/SaveCompartToolImage`, obj)
    .pipe(
      map((response: any) => response as MeasurementImage[]),
      catchError(this.handleError)
    );
  }

  //get Compart Image
  public getComponentImg(compart_attach_auto: number,
    compartid_auto: number,
    type_auto: number,
    inspection_auto: number,
    comparttype_auto: number,
    tool_auto: number,
    position: number): Observable<GetComponentImage> {
    let obj = {
      'compart_attach_auto': compart_attach_auto,
      'compartid_auto': compartid_auto,
      'type_auto': type_auto,
      'inspection_auto': inspection_auto,
      'comparttype_auto': comparttype_auto,
      'tool_auto': tool_auto,
      'position': position
    };
    return this._http
      .post(`${BASE_URL}/getCompartImages`, obj)
      .map((response: Response) => {
        return <GetComponentImage>response.json()
      }).catch(this.handleError)
  }



  public getComponentTestingPointImg(compart_attach_auto: number,
    compartid_auto: number,
    type_auto: number,
    inspection_auto: number,
    comparttype_auto: number,
    tool_auto: number,
    position: number): Observable<GetComponentImage[]> {
    let obj = {
      'compart_attach_auto': compart_attach_auto,
      'compartid_auto': compartid_auto,
      'type_auto': type_auto,
      'inspection_auto': inspection_auto,
      'comparttype_auto': comparttype_auto,
      'tool_auto': tool_auto,
      'position': position
    };
    return this._http
      .post(`${BASE_URL}/getComparTestingPointtImages`, obj)
      .map((response: Response) => {
        return <GetComponentImage[]>response.json()
      }).catch(this.handleError)
  }

  //Save Compartment Image
  public saveCompartImage(compart_attach_auto: number,
    compartid_auto: number,
    type_auto: number,
    inspection_auto: number,
    comparttype_auto: number,
    tool_auto: number,
    position: number,
    attachment:string,
    imageName:string,
    modified_user:string): Observable<GetComponentImage[]> {

    let obj = {
      'compart_attach_auto': compart_attach_auto,
      'compartid_auto': compartid_auto,
      'type_auto': type_auto,
      'inspection_auto': inspection_auto,
      'comparttype_auto': comparttype_auto,
      'tool_auto': tool_auto,
      'position': position,
      'attachment':attachment,
      'imageName':imageName,
      'modified_user':modified_user
    };
    //return this._http.post(`${BASE_URL}/SaveCompartAttachment`, obj).pipe(catchError(this.handleError));
    //return this._http.post(`${BASE_URL}/InsertUpdateCompartImage`, obj).pipe(catchError(this.handleError));
    return this._http
    .post(`${BASE_URL}/InsertUpdateCompartImage`, obj)
    .pipe(
      // Cast the response to MeasurementImage[]
      map((response: any) => response as GetComponentImage[]),
      catchError(this.handleError)
    );
  }


// public getCompartList(): Observable<any> {
//   return this._http.get('api/Component/GetCompartList')
//     .pipe(
//       catchError(this.handleError) // Ensure proper error handling
//     );
// }

// public getCompartList(): Observable<GetComponentImage[]>{
//   this._http.get(`${BASE_URL}/getAllComaprtList`)
//     .map((data: Response) => {
     
//       return data.json() as GetComponentImage[];
//     }).toPromise().then(x => {
//       this.componentImage = x;
//     })
// }

public getCompartList(compartid_auto: string): Observable<GetComponentImage[]> {
  let obj = {
    'compartid_auto' :compartid_auto
  }
  // return this._http
  // .get(`${BASE_URL}/getAllComaprtList`,obj)
  //   .map((response: Response) => {
  //     return <GetComponentImage[]>response.json()
  //   }).catch(this.handleError)

  // return this._http
  // .post(`${BASE_URL}/getAllComaprtList`, obj)
  // .pipe(
  //   // Cast the response to MeasurementImage[]
  //   map((response: any) => response as GetComponentImage[]),
  //   catchError(this.handleError)
  // );
  return this._http
  .post(`${BASE_URL}/getAllComaprtList`, obj)
  .map((response: Response) => {
    return <GetComponentImage[]>response.json()
  }).catch(this.handleError)

  // return this._http
  // .post(`${BASE_URL}/getAllComaprtList`, obj)
  // .pipe(
  //   // Cast the response to MeasurementImage[]
  //   map((response: any) => response as GetComponentImage[]),
  //   catchError(this.handleError)
  // );
}



public saveCompartDetails( compartid_auto: string,
  compartid: string,
  compart: string,
  comparttype_auto: number,
  tool_auto: number,
  smcs_code: number,
  modified_user:string,
  compart_note:string,
  make_auto:number,
  budget_life:number,
  modelID:any,
  parentCompID:number,
  distanceBudget:number,
  CaseParTNumber:string,BERCOPartNumber:string,KTSUPartNumber:string,OEMPartNumber:string,
  ITMPartNumber:string,ITRPartNumber:string,Cost:number,QuantityInStock:number,PartLineId:number,
  ComponentPitch:number
  ): Observable<ServerReturnMessage> {

    let obj = {
      'compartid_auto' :compartid_auto,
      'compartid' :compartid,
      'compart' :compart,
      'smcs_code' :smcs_code,
      'comparttype_auto' :comparttype_auto,
      'modified_user' :modified_user,
      'compart_note' :compart_note,
      'make_auto' :make_auto,
      'tool_auto' :tool_auto,
      'budget_life' :budget_life,
      'modelID' :modelID,
      'parentCompID' :parentCompID,
      'DistanceBudget': distanceBudget,
      'CaseParTNumber':CaseParTNumber,
      'BERCOPartNumber':BERCOPartNumber,
      'KTSUPartNumber':KTSUPartNumber,
      'OEMPartNumber':OEMPartNumber,
      'ITMPartNumber':ITMPartNumber,
      'ITRPartNumber':ITRPartNumber,
      'Cost':Cost,
      'QuantityInStock':QuantityInStock,
      'PartLineId':PartLineId,
      'ComponentPitch':ComponentPitch
};
  //return this._http.post(`${BASE_URL}/SaveCompartAttachment`, obj).pipe(catchError(this.handleError));
 // return this._http.post<ServerReturnMessage>(`${BASE_URL}/SaveCompartDetails`, obj).pipe(catchError(this.handleError));
  return this._http
  .post(`${BASE_URL}/SaveCompartDetails`, obj)
  .pipe(
    // Cast the response to MeasurementImage[]
    map((response: any) => response.json()),
    catchError(this.handleError)
  );


}



public deleteCompart(compartid_auto: string) {
  let obj = {
    'compartid_auto': compartid_auto
  };
  return this._http
    .post(`${BASE_URL}/deleteCompartDetails`, obj)
    .map((response: Response) => {
      return response.json()
    }).catch(this.handleError)
}

  private handleError(error: Response) {
    return Observable.throw(error || 'Server error');
  }

  public updateSproketHardware(compartid_auto: string,CasePartNumberSproket:string,
    BercoPartNumberSproket:string,Description:string,Quantity:number,
    partLineID:number,chainAutoID:number,cost:number,IsUpdate:number) {
    let obj = {
      'compartid_auto': compartid_auto,
      'CasePartNumberSproket':CasePartNumberSproket,
      'BercoPartNumberSproket':BercoPartNumberSproket,
      'Description':Description,
      'Quantity':Quantity,
      'PartLineId':partLineID,
      'ChainAutoID':chainAutoID,
      'Cost':cost,
      'IsUpdate':IsUpdate
    };
    //return this._http.post(`${BASE_URL}/SaveCompartAttachment`, obj).pipe(catchError(this.handleError));
    //return this._http.post<number>(`${BASE_URL}/UpdateSproketHardware`, obj).pipe(catchError(this.handleError));


    return this._http
    .post(`${BASE_URL}/UpdateSproketHardware`, obj)
    .pipe(
      // Cast the response to MeasurementImage[]
      map((response: any) => response as any),
      catchError(this.handleError)
    );


  }

  public GetSproketData(compartid_auto: number,chainautioID:number): Observable<UpdateComponentSproket> {
    let params={ compartid_auto: compartid_auto,
      chainAutoId:chainautioID
    };
    
    let options = {
      params: new HttpParams().set('compartid_auto', compartid_auto.toString())
          .set('chainAutoId', chainautioID)
  };

    return this._http.get('api/Component/GetSproketHardwareData', { search: params }).share().map(
        (response: Response) => <UpdateComponentSproket>response.json()).catch(this.handleError);
  }

  public getParentID(compartid_auto: string) : Observable<number> {
    let obj = {
      'compartid_auto': compartid_auto
    };

    // return this._http.post('api/Component/getCompartParentId', { search: obj }).share().map(
    //   (response: Response) => <number>response.json()).catch(this.handleError);

      return this._http
      .post(`${BASE_URL}/getCompartParentId`, obj)
      .map((response: Response) => {
        return <number>response.json()
      }).catch(this.handleError)
  }

  // public getAllComponentList(progid: string, ComponentId: string, ComponentDescription: string, ComponentType: string, EquipMake: string, ComponentMake: string, EquipModel: string): Observable<ComponentList[]> {

  //   let obj = {
  //     'progid': progid,
  //     'ComponentId': ComponentId,
  //     'ComponentDescription': ComponentDescription,
  //     'ComponentType': ComponentType,
  //     'EquipMake': EquipMake,
  //     'ComponentMake': ComponentMake,
  //     'EquipModel': EquipModel
  //   };
  //   return this._http
  //     .post(`${BASE_URL}/GetComponents`, obj)
  //     .map((response: Response) => {
  //       return <ComponentList[]>response.json()
  //     }).catch(this.handleError)
  // }






public GetMakeFromFamily(familyId: number): Observable<MakeViewModel[]> {
  let params={ familyid: familyId};
  return this._http.get('api/GETSetupEquipment/GetMakeFromFamily', { search: params }).share().map(
      (response: Response) => <MakeViewModel[]>response.json()).catch(this.handleError);
}


  public UpdateCompartModelChain(CompartModelMappingAuto: number,ChainAutoID:number,
    ChainModelComponentMapId:number,IsActive:number) {
    let obj = {
      'CompartModelMappingAuto': CompartModelMappingAuto,
      'ChainAutoID':ChainAutoID,
      'ChainModelComponentMapId':ChainModelComponentMapId,
      'IsActive':IsActive,

    };
    return this._http.post(`api/SetupModel/UpdateCompartModelChain`, obj).pipe(catchError(this.handleError));

  }
  public GetSproket(compartid_auto: Number): Observable<UpdateComponentSproket[]> {
    let params={ compartid_auto: compartid_auto,
    };
    
    let options = {
      params: new HttpParams().set('compartid_auto', compartid_auto.toString())
  };

    return this._http.get('api/Component/GetSprocket', { search: params }).share().map(
        (response: Response) => <UpdateComponentSproket[]>response.json()).catch(this.handleError);
  }
  public updateSproketHardwareData(partConfigAuto:number,compartid_auto: string,CasePartNumberSproket:string,
    BercoPartNumberSproket:string,Description:string,Quantity:number,
    partLineID:number,chainAutoID:number,cost:number,IsUpdate:number) {
    let obj = {
      'compartid_auto': compartid_auto,
      'CasePartNumberSproket':CasePartNumberSproket,
      'BercoPartNumberSproket':BercoPartNumberSproket,
      'Description':Description,
      'Quantity':Quantity,
      'PartLineId':partLineID,
      'ChainAutoID':chainAutoID,
      'Cost':cost,
      'IsUpdate':IsUpdate,
      'PartConfiqAuto':partConfigAuto
    };
    return this._http
    .post(`${BASE_URL}/UpdateSproketHardwareRow`, obj)
    .pipe(
      // Cast the response to MeasurementImage[]
      map((response: any) => response as any),
      catchError(this.handleError)
    );


  }
  public ChangeObsPointVisibility(Id:number,isVisible:number): Observable<number> {
    let params={ MeasurementPointId: Id,
      isVisible:isVisible
    };
    return this._http.get('api/Components/ChangeObsPointVisibility', { search: params }).share().map(
        (response: Response) => <number>response.json()).catch(this.handleError);
  }
 
  public GetActionHistoryComponent(HistoryId: number): Observable<ActionHistoryComponentData[]> {
    let params={ HistoryId: HistoryId};
    return this._http.get('api/Component/GetActionHistoryComponent', { search: params }).share().map(
        (response: Response) => <ActionHistoryComponentData[]>response.json()).catch(this.handleError);
  }
//   public GetActionHistoryComponent(HistoryId : number): Observable<ActionHistoryComponentData[]> {
       
       
//     const options = {
//         params: new HttpParams().set('HistoryId', HistoryId)
//     };
//     return this._http.get('api/Component/GetActionHistoryComponent',options).pipe(catchError(this.handleError));
// }

public UpdateComponentCost(updateData: UpdateComponentCost): Observable<number> {

  
  return this._http
    .post(`api/Component/SaveActionHistoryComponent`, updateData)
    .map((response: Response) => {
      return <number>response.json()
    }).catch(this.handleError)
}
  
}